/* @flow */

import * as React from 'react';
import { useCallback, useRef } from 'react';

import type { ModalState } from '../../../redux/modal/reducers';

import Localizer from '../../../helpers/localization';
import ButtonFX from '../../buttons/ButtonFX';
import { WidthKind } from '../../buttons/types';
import Modal, { ModalView } from '../modal';
import './EulaModal.css';

const { Fragment } = React;

export enum EulaModalResult {
  Accept,
  Decline,
  Cancel,
}

export type EULA_DATA_MODAL_TYPE = { text: string };

const EulaModal = ({ eulaData }: ModalState): React.Node => {
  const modalRef = useRef<ModalView | null>(null);

  const setModalRef = useCallback((instance: ModalView | null) => {
    modalRef.current = instance;
  }, []);

  const close = useCallback((result: EulaModalResult) => {
    modalRef.current?.close(result);
  }, []);

  const handleAcceptOnClick = useCallback(() => {
    close(EulaModalResult.Accept);
  }, [close]);

  const handleDeclineOnClick = useCallback(() => {
    close(EulaModalResult.Decline);
  }, [close]);

  const renderEula = useCallback((): React.Node => {
    if (!eulaData) {
      return null;
    }

    const { text } = eulaData;

    return (
      <div className='text'>
        {text.split('\n').map((line: string) => (
          <Fragment key={line}>
            {line}
            <br />
          </Fragment>
        ))}
      </div>
    );
  }, [eulaData]);

  return (
    <Modal ariaLabel={Localizer.localize('accessibility.modal.eula')} className='eula' header={Localizer.localize('gaming.eula.header')} innerRef={setModalRef} isAlert>
      {renderEula()}
      <div className='buttons'>
        <ButtonFX key='accept' onClick={handleAcceptOnClick} widthKind={WidthKind.Stretched}>
          {Localizer.localize('gaming.actions.eula_accept')}
        </ButtonFX>
        <ButtonFX key='decline' onClick={handleDeclineOnClick} widthKind={WidthKind.Stretched}>
          {Localizer.localize('gaming.actions.eula_decline')}
        </ButtonFX>
      </div>
    </Modal>
  );
};

export default EulaModal;
